/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum UserStatusEnum {
  'userStatusActive' = 'active',
  'userStatusInactive' = 'inactive',
  'userStatusPending' = 'pending',
}

export type UserStatus = UserStatusEnum